const radius = {
  0: 0,
  50: 4,
  100: 8,
  200: 16,
  300: 24,
  400: 32,
  500: 64,
};

export { radius };
